import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';
import { l as angleDown } from '../../LocalModules/storm-ui-icons/dist/esm/localIcons-9_jhfe7X-DyCR5FH7.js';
import { I as Icon } from '../../Icon/Icon-Cgh13Jz2.js';

const PositionedIcon = /*#__PURE__*/styled(Icon).withConfig({
  componentId: "sc-storm-ui-40025937__sc-kfvljt-0"
})(["margin-inline-start:", ";", ""], ({
  theme
}) => theme.spacing.xxsmall.default, isMobile(css(["margin-inline-start:", ";"], ({
  theme
}) => theme.spacing.xxsmall.mobile)));
const DefaultFooter = ({
  label
}) => /*#__PURE__*/React__default.createElement(React__default.Fragment, null, label, /*#__PURE__*/React__default.createElement(PositionedIcon, {
  type: angleDown
}));

export { DefaultFooter as D };
//# sourceMappingURL=DefaultFooter-BvoHUEFA.js.map
